import React from 'react';

import { Text } from '@zapier/design-system';

import Link from 'app/common/components/Link';
import LinkButton from 'app/common/components/LinkButton';
import { useAvroEvent } from 'app/developer-v3/hooks';
import {
  BASE_DOC_URL_VB,
  DEVELOPER_CLI_GUIDE_URL,
} from 'app/developer-v3/constants';

import CTA from './CTA';

type Props = {
  createAppUrl: string;
};

function CTAStart({ createAppUrl }: Props) {
  const { emitUserInteractionEvent } = useAvroEvent();

  return (
    <CTA>
      <CTA.Main hasAside={true}>
        <CTA.Header>Build a Zapier integration</CTA.Header>
        <CTA.Body>
          <Text color="gray60" tag="p" type="smallPrint1">
            Zapier’s Free Developer Platform connects your API to the web’s top
            apps. Get a step by step walk-through of a Zapier integation in our{' '}
            <Link
              href={`${BASE_DOC_URL_VB}/quickstart/how-zapier-works`}
              target="_blank"
            >
              Quick Start Guide
            </Link>
            .
          </Text>
        </CTA.Body>
      </CTA.Main>
      <CTA.Aside>
        <LinkButton
          color="primary"
          href={createAppUrl}
          onClick={() =>
            emitUserInteractionEvent({
              eventAction: 'click',
              interactionRawText: 'Start a Zapier Integration',
              interactionName: 'start_integration',
              interactionGoal:
                'Start creating a Zapier integration using the UI',
            })
          }
          size="small"
        >
          Start a Zapier integration
        </LinkButton>
        <Text
          color="gray60"
          margin="10px 0px 0px 0px"
          tag="p"
          type="smallPrint1"
        >
          Or start your integration{' '}
          <Link href={DEVELOPER_CLI_GUIDE_URL} target="_blank">
            with the CLI
          </Link>
        </Text>
      </CTA.Aside>
    </CTA>
  );
}

export default CTAStart;
